import { render, staticRenderFns } from "./resume-rooms.vue?vue&type=template&id=836c89da&scoped=true"
import script from "./resume-rooms.vue?vue&type=script&lang=js"
export * from "./resume-rooms.vue?vue&type=script&lang=js"
import style0 from "./resume-rooms.vue?vue&type=style&index=0&id=836c89da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836c89da",
  null
  
)

export default component.exports